// FREEZER OBJECTS — hand-drawn cartoon SVGs. Swap any of these for real images later.
// Art language: plates/bowls, glossy highlights, soft shading — Tom & Jerry fridge energy.
const INK = "#2B2320";
const S = { stroke: INK, strokeWidth: 4, strokeLinejoin: "round", strokeLinecap: "round" };
const Hand = { fontFamily: "'Kalam',cursive", fontWeight: 700 };

export const IceCream = () => (
  <svg viewBox="0 0 100 100" className="w-full h-full overflow-visible">
    <g {...S}>
      <path d="M20 32 h60 v42 a10 10 0 0 1 -10 10 h-40 a10 10 0 0 1 -10 -10 z" fill="#FF8FB1" />
      <path d="M62 32 h18 v42 a10 10 0 0 1 -10 10 h-18 z" fill="#F47AA2" strokeWidth="3" />
      <rect x="20" y="50" width="60" height="17" fill="#FFF3D6" strokeWidth="3" />
      <ellipse cx="50" cy="32" rx="31" ry="9.5" fill="#F6EFE7" />
      <ellipse cx="50" cy="30.5" rx="31" ry="8" fill="#FBF7F0" />
      <ellipse cx="50" cy="30" rx="21" ry="5" fill="#EADFD3" strokeWidth="3" />
      <path d="M28 28 q8 -5 16 -4" stroke="#fff" strokeWidth="3" fill="none" opacity="0.9" />
      <path d="M76 60 q4 8 0 12 q-4 -4 0 -12" fill="#FF8FB1" strokeWidth="2.5" />
      <circle cx="30" cy="58.5" r="4.5" fill="#FF8FB1" strokeWidth="2.5" />
      <path d="M26 63 l4 -4 4 4" fill="none" strokeWidth="2" />
    </g>
  </svg>
);

export const FrozenFish = () => (
  <svg viewBox="0 0 100 100" className="w-full h-full overflow-visible">
    <g {...S}>
      <ellipse cx="50" cy="80" rx="44" ry="11" fill="#F6F9FC" />
      <ellipse cx="50" cy="79" rx="34" ry="7.5" fill="#E4ECF2" strokeWidth="2.5" />
      <path d="M16 60 C24 40 52 34 70 46 C77 50 81 55 84 58 C79 65 68 72 52 73 C34 74 20 69 16 60 Z" fill="#9CC2D6" />
      <path d="M16 60 C22 68 36 72 52 71 C66 70 76 64 82 59 C78 66 66 72 52 73 C34 74 20 69 16 60 Z" fill="#7FAEC4" strokeWidth="2.5" />
      <path d="M20 54 C28 42 50 37 66 46" stroke="#DFF3FF" strokeWidth="6" fill="none" opacity="0.9" strokeLinecap="round" />
      <path d="M84 58 L96 44 L92 58 L96 72 Z" fill="#8FB4C9" />
      <path d="M86 50 L94 44 M86 66 L94 72" strokeWidth="2" fill="none" />
      <path d="M36 54 q4 4 8 0 M44 52 q4 4 8 0 M52 54 q4 4 8 0 M40 60 q4 4 8 0 M48 62 q4 4 8 0" strokeWidth="1.8" fill="none" opacity="0.55" />
      <path d="M28 48 q6 7 0 15" strokeWidth="2.5" fill="none" />
      <path d="M18 62 q4 2 7 1" strokeWidth="2.5" fill="none" />
      <path d="M40 48 l7 7 M47 48 l-7 7" strokeWidth="3" />
      <path d="M62 73 q2 6 -1 8 q-3 -2 -1 -8" fill="#DFF3FF" strokeWidth="2" />
    </g>
    <g stroke="#EFF8FF" strokeWidth="2.5" strokeLinecap="round">
      <path d="M30 36 v-6 M26 33 h8 M74 34 v-6 M70 31 h8 M88 48 v-6 M84 45 h8" fill="none" />
    </g>
  </svg>
);

export const Kulfi = () => (
  <svg viewBox="0 0 100 100" className="w-full h-full overflow-visible">
    <g {...S}>
      <ellipse cx="52" cy="84" rx="40" ry="10" fill="#F6F9FC" />
      <ellipse cx="52" cy="83" rx="31" ry="7" fill="#E4ECF2" strokeWidth="2.5" />
      <ellipse cx="60" cy="80" rx="14" ry="4" fill="#FFF3D6" strokeWidth="2" />
      <rect x="42" y="66" width="9" height="20" rx="4" fill="#D9A066" />
      <path d="M48 10 L68 62 q4 8 -4 10 h-30 q-8 -2 -4 -10 z" fill="#FFF3D6" />
      <path d="M48 10 L68 62 q4 8 -4 10 h-16 z" fill="#F7E4BE" strokeWidth="3" />
      <path d="M42 32 q6 3 12 0 M40 44 q8 3 16 0" strokeWidth="2.2" fill="none" opacity="0.5" />
      <circle cx="44" cy="24" r="1.8" fill="#7FBF4D" strokeWidth="1" />
      <circle cx="54" cy="38" r="1.8" fill="#7FBF4D" strokeWidth="1" />
      <circle cx="46" cy="50" r="1.8" fill="#7FBF4D" strokeWidth="1" />
      <circle cx="58" cy="26" r="1.5" fill="#E8A0B4" strokeWidth="1" />
      <path d="M64 58 q3 6 0 10 q-4 -3 -2 -9" fill="#F7E4BE" strokeWidth="2" />
    </g>
  </svg>
);

export const Popsicle = () => (
  <svg viewBox="0 0 100 100" className="w-full h-full overflow-visible">
    <g {...S}>
      <rect x="34" y="70" width="10" height="22" rx="4" fill="#D9A066" />
      <path d="M38 74 v14" stroke="#B06A1F" strokeWidth="2" fill="none" opacity="0.6" />
      <path d="M30 12 h28 a10 10 0 0 1 10 10 v34 a14 14 0 0 1 -14 14 h-20 a14 14 0 0 1 -14 -14 v-34 a10 10 0 0 1 10 -10 z" fill="#FF6B6B" />
      <rect x="20" y="38" width="48" height="7" fill="#FFD166" strokeWidth="3" />
      <path d="M26 16 q-2 16 2 30" stroke="#FF9E9E" strokeWidth="3" fill="none" opacity="0.85" />
      <path d="M64 48 q4 8 0 13 q-5 -4 -1 -12" fill="#FF6B6B" strokeWidth="2.5" />
      <circle cx="64" cy="20" r="7" fill="#FFF3D6" strokeWidth="3.5" />
    </g>
  </svg>
);

export const PeasPacket = () => (
  <svg viewBox="0 0 100 100" className="w-full h-full overflow-visible">
    <g {...S}>
      <path d="M26 16 h48 l6 8 v52 l-6 8 h-48 l-6 -8 v-52 z" fill="#7FBF4D" />
      <path d="M20 24 h60 M20 78 h60" strokeWidth="3" fill="none" />
      <path d="M26 16 l-6 8 M74 16 l6 8 M26 84 l-6 -8 M74 84 l6 -8" strokeWidth="2.5" fill="none" />
      <path d="M24 32 l10 -4 M22 70 l8 -3" stroke="#DFF3FF" strokeWidth="3" fill="none" opacity="0.8" />
      <rect x="30" y="42" width="40" height="26" rx="7" fill="#DFF3E3" strokeWidth="3.5" />
      <circle cx="41" cy="56" r="6" fill="#5EA332" strokeWidth="3" />
      <circle cx="55" cy="59" r="6" fill="#5EA332" strokeWidth="3" />
      <circle cx="63" cy="49" r="6" fill="#5EA332" strokeWidth="3" />
      <circle cx="40" cy="54" r="1.6" fill="#BFE8A8" strokeWidth="1" />
      <circle cx="54" cy="57" r="1.6" fill="#BFE8A8" strokeWidth="1" />
    </g>
  </svg>
);

export const PizzaBox = () => (
  <svg viewBox="0 0 100 100" className="w-full h-full overflow-visible">
    <g {...S}>
      <path d="M14 42 L86 34 L90 62 L18 72 Z" fill="#E8B968" />
      <path d="M14 42 L86 34 L84 26 L16 32 Z" fill="#F3D98B" />
      <path d="M30 46 l14 10 l-14 4 z" fill="#FFD166" strokeWidth="2.5" transform="rotate(-5 37 52)" />
      <circle cx="36" cy="50" r="1.8" fill="#E8563F" strokeWidth="1.5" />
      <path d="M26 58 l10 -3 M46 62 l14 -4" stroke="#fff" strokeWidth="3" fill="none" />
    </g>
  </svg>
);

export const IceCubeTray = () => (
  <svg viewBox="0 0 100 100" className="w-full h-full overflow-visible">
    <g {...S}>
      <rect x="12" y="34" width="64" height="46" rx="8" fill="#F6F9FC" />
      <rect x="20" y="42" width="16" height="16" rx="4" fill="#CDEBFF" strokeWidth="3.5" />
      <rect x="42" y="42" width="16" height="16" rx="4" fill="#CDEBFF" strokeWidth="3.5" />
      <rect x="20" y="62" width="16" height="12" rx="4" fill="#CDEBFF" strokeWidth="3.5" />
      <rect x="42" y="62" width="16" height="12" rx="4" fill="#CDEBFF" strokeWidth="3.5" />
      <rect x="66" y="14" width="20" height="20" rx="5" fill="#DFF3FF" transform="rotate(12 76 24)" />
      <path d="M72 9 v-5 M69 6 h6" stroke="#9ADCF5" strokeWidth="3" fill="none" />
    </g>
  </svg>
);